/**
 * Warm the browser cache for an image URL (e.g. poster before navigation).
 * Safe to call repeatedly; duplicates are cheap once cached.
 */
export function preloadImageUrl(url: string | null | undefined): void {
  if (!url || typeof window === 'undefined') return;
  const trimmed = url.trim();
  if (!trimmed) return;
  const img = new Image();
  img.src = trimmed;
}

/** Last preload time per URL — avoids duplicate work from pointer + touch on the same card. */
const lastPreloadAtByUrl = new Map<string, number>();
const DEBOUNCE_MS = 600;

/**
 * Same as preloadImageUrl but ignores repeat calls for the same URL within DEBOUNCE_MS.
 * Use from pointer/touch handlers so desktop hover and Capacitor touch both work without spamming during scroll.
 */
export function preloadImageUrlDebounced(url: string | null | undefined): void {
  if (!url || typeof window === 'undefined') return;
  const trimmed = url.trim();
  if (!trimmed) return;
  const now = Date.now();
  const prev = lastPreloadAtByUrl.get(trimmed) ?? 0;
  if (now - prev < DEBOUNCE_MS) return;
  lastPreloadAtByUrl.set(trimmed, now);
  if (lastPreloadAtByUrl.size > 300) {
    lastPreloadAtByUrl.clear();
  }
  preloadImageUrl(trimmed);
}
